<template>
  <div>
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else>
        <div class="ticket_list_header">
            <div class="d_flex_btwn">
                <div class="d_flex_start">
                    <router-link :to="{name: 'support-requests'}" class="btn btn_black mr_10 d_flex_center has_border_radius">Back to List</router-link>
                    <router-link :to="`/support-request/${singleTicket.id}`">
                        <button type="button" modal-target="smodal" class="btn  btn_transparent has_border_radius mr_10 d_flex_center">
                            <span class="mr_5 d_flex_center"><img src="@/assets/media/images/edit.png" alt=""></span>
                            <span class="d_flex_center no_line_height">Edit</span>
                        </button>
                    </router-link>
                    <button type="button"  class="btn  btn_transparent has_border_radius mr_10 d_flex_center" @click="openCreateChatTicket">
                        <span class="mr_5 d_flex_center"><i class="lni lni-plus"></i></span> 
                        <span>Create Ticket</span> 
                    </button>
                </div>

                <div class="d_flex_center">
                    <button v-if="singleTicket.tickets && singleTicket.tickets.length > 0" @click="viewTicketsToggle" type="button" class="btn  btn_transparent has_border_radius mr_10 d_flex_center">
                        <span class="mr_5 d_flex_center">
                            <i class="lni lni-alarm-clock"></i>
                        </span> 
                        <span>View tickets</span> 
                    </button>
                    <div class="retail_pagination p_0 mr_10">
                        <ul>
                            <li v-if="singleTicket.previous_support_id">
                                <router-link :to="`/support-request/${singleTicket.previous_support_id}/show`">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 mr-[1px] lg:w-5 lg:h-5 lg:mr-[2px]">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5"></path>
                                        </svg>
                                </router-link>
                            </li>
                            <li v-if="singleTicket.next_support_id">
                                <router-link :to="`/support-request/${singleTicket.next_support_id}/show`">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 ml-[1px] lg:w-5 lg:h-5 lg:ml-[2px]">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5"></path>
                                    </svg>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="vlan_ticket_list_details_page ticket_contact_list_details_page ">
            <div class="vlan_ticket_list_page_wrap vlan_ticket_list_all_wrap collapse_contact_open ticket_contact_list_details_page_wrap ">
                <div class="vlan_ticket_list_left ticket_contact_list_details_left">
                    <div class="vlan_ticket_list_left_wrap ticket_contact_list_details_left_wrap">
                        <div class="vlan_ticket_list_table_wrap vlan_ticket_list_details_table_wrap ticket_contact_list_details_table_wrap">
                            <div class="mail_box_details_head">
                                <h2>
                                    <span class="fw_500 mr_10">{{ singleTicket.subject }}</span>
                                    <button type="button" class="btn btn_sm btn_black">{{ singleTicket.request_from }}</button>
                                </h2>
                            </div>
                            <div class="ticket_mail_box_details">
                                <div class="mail_details_content">
                                    <template v-if="!showTickets">
                                        <div class="mail_box_head_wrap">
                                            <div class="left">
                                                <div class="author">
                                                    <img :src="singleTicket?.contact?.photo" alt="">
                                                </div>
                                                <div class="content_details">
                                                    <p><b>{{ singleTicket.name }}</b> {{ singleTicket.email }}</p>
                                                    <p>{{ singleTicket.formatted_created_at }}  ({{ singleTicket.created_at }})</p>
                                                    <p> 
                                                        <b class="fw_500">To:</b><span class="mr_10">support@vlan24.com</span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-html="singleTicket.message"></div>
                                    </template>
                                    <template v-else>
                                        <div class="contact_details_content">
                                            <nav class="tabs">
                                                <ul class="">
                                                    <li href="#tab1" class="active"> TICKETS   </li>
                                                </ul>   
                                            </nav>
                                            <div class="tab_content_wrapper">
                                                <div id="tab2" class="tab_content show">
                                                    <div class="fadein">
                                                        <div class="contact_details_content_wrap">
                                                            <div class="inner" v-for="(ticket, ticketIndex) in singleTicket.tickets" :key="'ticket_'+ticketIndex">
                                                                <div class="inner_wrap">
                                                                    <div class="img">
                                                                        <svg fill="#000000" width="34px" height="34px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>ticket</title> <path d="M22.996 10.75h-13.996c-0.69 0-1.25 0.56-1.25 1.25v0 7.605c0 0.69 0.56 1.25 1.25 1.25h13.996c0.69-0.001 1.249-0.56 1.25-1.25v-7.606c-0-0.69-0.56-1.25-1.25-1.25h-0zM21.746 18.355h-11.496v-5.105h11.496zM30 14.25c0.69-0 1.25-0.56 1.25-1.25v-5c-0-0.69-0.56-1.25-1.25-1.25h-28c-0.69 0-1.25 0.56-1.25 1.25v0 5c0 0.69 0.56 1.25 1.25 1.25v0c0.966 0 1.75 0.784 1.75 1.75s-0.784 1.75-1.75 1.75v0c-0.69 0-1.25 0.56-1.25 1.25v5c0 0.69 0.56 1.25 1.25 1.25h28c0.69-0.001 1.249-0.56 1.25-1.25v-5c-0.001-0.69-0.56-1.249-1.25-1.25h-0c-0.966 0-1.75-0.784-1.75-1.75s0.784-1.75 1.75-1.75v0zM28.75 20.041v2.709h-25.5v-2.709c1.75-0.541 3-2.145 3-4.041s-1.25-3.5-2.97-4.033l-0.030-0.008v-2.709h25.5v2.709c-1.75 0.541-3 2.145-3 4.041s1.25 3.5 2.97 4.033l0.030 0.008z"></path> </g></svg>
                                                                    </div>
                                                                    <div class="text">
                                                                        <div class="title">
                                                                            <router-link :to="`/ticket/${ticket.ticket_number}`">{{ ticket.subject }} # {{ ticket.ticket_number }}</router-link>
                                                                        </div>
                                                                        <div class="info"> <span class="mr_5">Status: {{ ticket.status }}</span> <span v-if="ticket.group"> Group: {{ ticket.group.name }}</span> </div>
                                                                        
                                                                        <div class="info"> 
                                                                            <span v-if="ticket.closed_at_readable" class="mr_5">Closed: {{ ticket.closed_at_readable }}</span>
                                                                            <span v-else-if="ticket.resolved_at_readable" class="mr_5">Resolved: {{ ticket.resolved_at_readable }}</span>
                                                                            <span v-else class="mr_5">Created: {{ ticket.formatted_created_at }}</span>
                                                                            <span v-if="ticket.resolution_status" class="mr_5"><span>{{ ticket.resolution_status }}</span></span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="vlan_ticket_list_all_right">
                    <div class="vlan_ticket_list_all_filter">
                        <div class="vlan_ticket_list_all_filter_inner">
                            <div class="accordion_wrap">
                                <div class="accordion">
                                    <div class="accordion_heading">
                                        <div class="accordion_heading_inner open" data-toggle="collapse_slide" data-target="#cCard2"> 
                                            <span><svg width="15px" height="15px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools --> <title>ic_fluent_contact_card_group_24_regular</title> <desc>Created with Sketch.</desc> <g id="🔍-Product-Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="ic_fluent_contact_card_group_24_regular" fill="#212121" fill-rule="nonzero"> <path d="M18.75,4 C20.5449254,4 22,5.45507456 22,7.25 L22,16.754591 C22,18.5495164 20.5449254,20.004591 18.75,20.004591 L5.25,20.004591 C3.45507456,20.004591 2,18.5495164 2,16.754591 L2,7.25 C2,5.51696854 3.35645477,4.10075407 5.06557609,4.00514479 L5.25,4 L18.75,4 Z M18.75,5.5 L5.25,5.5 L5.10647279,5.5058012 C4.20711027,5.57880766 3.5,6.3318266 3.5,7.25 L3.5,16.754591 C3.5,17.7210893 4.28350169,18.504591 5.25,18.504591 L18.75,18.504591 C19.7164983,18.504591 20.5,17.7210893 20.5,16.754591 L20.5,7.25 C20.5,6.28350169 19.7164983,5.5 18.75,5.5 Z M9.25257038,12.5 C9.66678394,12.5 10.0025704,12.8357864 10.0025704,13.25 L10.0025704,13.8321918 C10.0025704,15.1041956 9.0341,15.75 7.50128519,15.75 C5.96840664,15.75 5,15.1036013 5,13.8310402 L5,13.25 C5,12.8357864 5.33578644,12.5 5.75,12.5 L9.25257038,12.5 Z M10.8334902,12.4985863 L12.25,12.5 C12.6642136,12.5 13,12.8357864 13,13.25 L13,13.582681 C13,14.5462268 12.2350063,15 11.125,15 C11.0088628,15 10.8965027,14.9950281 10.7884008,14.9850208 C10.9003752,14.7160989 10.9702591,14.4160784 10.9937337,14.0856775 L11.0025704,13.8321918 L11.0025704,13.25 C11.0025704,12.9810441 10.9418968,12.7262593 10.8334902,12.4985863 Z M15.2496688,12.5 L18.25,12.5 C18.6642136,12.5 19,12.8357864 19,13.25 C19,13.6296958 18.7178461,13.943491 18.3517706,13.9931534 L18.25,14 L15.2496688,14 C14.8354552,14 14.4996688,13.6642136 14.4996688,13.25 C14.4996688,12.8703042 14.7818227,12.556509 15.1478982,12.5068466 L15.2496688,12.5 L18.25,12.5 L15.2496688,12.5 Z M7.50071279,8.5 C8.32953357,8.5 9.00142557,9.171892 9.00142557,10.0007128 C9.00142557,10.8295336 8.32953357,11.5014256 7.50071279,11.5014256 C6.671892,11.5014256 6,10.8295336 6,10.0007128 C6,9.171892 6.671892,8.5 7.50071279,8.5 Z M11.3699891,9.00225167 C12.0591015,9.00225167 12.6177374,9.56088763 12.6177374,10.25 C12.6177374,10.9391124 12.0591015,11.4977483 11.3699891,11.4977483 C10.6808767,11.4977483 10.1222408,10.9391124 10.1222408,10.25 C10.1222408,9.56088763 10.6808767,9.00225167 11.3699891,9.00225167 Z M15.2496688,9.5 L18.25,9.5 C18.6642136,9.5 19,9.83578644 19,10.25 C19,10.6296958 18.7178461,10.943491 18.3517706,10.9931534 L18.25,11 L15.2496688,11 C14.8354552,11 14.4996688,10.6642136 14.4996688,10.25 C14.4996688,9.87030423 14.7818227,9.55650904 15.1478982,9.50684662 L15.2496688,9.5 L18.25,9.5 L15.2496688,9.5 Z" id="🎨-Color"> </path> </g> </g> </g></svg></span> 
                                            <span>Contact Details</span>  
                                        </div>
                                    </div>
                                    <div class="accordion_body" id="cCard2" style="display: block;">
                                        <div class="t_c_contact_wrap">
                                            <template v-if="singleTicket.contact">
                                                <div class="inner mb_20" >
                                                    <div class="inner_wrap">
                                                        <router-link :to="`/contact/${singleTicket.contact_id}/show`">
                                                            <div class="contact_name">
                                                                <div class="avatar info_bg">
                                                                    <span>{{ singleTicket.contact.name.charAt(0) }}</span>
                                                                </div>
                                                                <div class="text">
                                                                    <p>{{ singleTicket.contact.name }}</p>
                                                                    <p>{{ singleTicket.contact.title }}</p>
                                                                </div>
                                                            </div>
                                                        </router-link>
                                                    </div>
                                                </div>
                                                <div class="form_row">
                                                    <label> Company</label>
                                                    <div class="form_input">
                                                        <router-link :to="`/company/${singleTicket.company_id}/show`">
                                                            {{ singleTicket.company_name }}
                                                        </router-link>
                                                    </div>
                                                </div>
                                                <div class="form_row">
                                                    <label> Email</label>
                                                    <div class="form_input">
                                                        {{ singleTicket.contact.email }}
                                                    </div>
                                                </div>
                                                <div class="d_flex_start pt_5 pb_20">
                                                    <router-link class="btn  btn_transparent has_border_radius mr_10 d_flex_center" :to="`/contact/${singleTicket.contact_id}/show`">View More Info</router-link>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--  start right sidebar ticket form-->
        <div class="right_menu">
            <h2 > <span>Ticket</span>
                <div class="close_right_menu cursor_pointer" @click="closeCreateChatTicket">
                <span><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"></path></svg></span>
                </div>
            </h2>
            <div class="right_menu_content">
                <div class="row">
                    <div class="col_6">
                        <div :class="['form_row', {'has_error': errorFor('group_id')}]">
                            <label class="required">Group</label>
                            <Multiselect
                                v-model="selectedGroup"
                                :options="groups"
                                :multiple="false"
                                :close-on-select="true"
                                placeholder="Select a group"
                                label="name"
                                track-by="id"
                                :optionHeight="20"
                                @Select="onGroupSelect"
                                @remove="onGroupRemove"
                            />
                            <v-errors :errors="errorFor('group_id')"></v-errors>
                        </div>
                    </div>
                    <div class="col_6">
                        <div :class="['form_row', {'has_error': errorFor('user_id')}]">
                            <label class="required">User</label>
                            <Multiselect
                                v-model="selectedUser"
                                :options="users"
                                :multiple="true"
                                :optionHeight="20"
                                :close-on-select="true"
                                placeholder="Select a user"
                                label="name"
                                track-by="id"
                                @remove="onUserRemove"
                            />
                            <v-errors :errors="errorFor('user_id')"></v-errors>
                        </div>
                    </div>
                    <div class="col_6">
                        <div :class="['form_row', {'has_error': errorFor('status')}]">
                            <label class="required">Status</label>
                            <Multiselect
                                v-model="selectedStatus"
                                :options="statuses"
                                :multiple="false"
                                :close-on-select="true"
                                :optionHeight="20"
                                placeholder="Select a status"
                                label="name"
                                track-by="label"
                                @Select="onStatusSelect"
                                @remove="onStatusRemove"
                            />
                            <v-errors :errors="errorFor('status')"></v-errors>
                        </div>
                    </div>
                    <div class="col_6">
                        <div :class="['form_row', {'has_error': errorFor('priority')}]">
                            <label class="required">Priority</label>
                            <Multiselect
                                v-model="selectedPriority"
                                :options="priorities"
                                :multiple="false"
                                :optionHeight="20"
                                :close-on-select="true"
                                placeholder="Select a priority"
                                label="name"
                                track-by="label"
                                @Select="onPrioritySelect"
                                @remove="onPriorityRemove"
                            />
                            <v-errors :errors="errorFor('priority')"></v-errors>
                        </div>
                    </div>
                    <div class="col_12">
                        <div :class="['form_row', {'has_error': errorFor('subject')}]">
                            <label class="required">Subject</label>
                            <div class="form_inline">
                                <input type="text" class="form_global" v-model="ticket.subject">
                                <v-errors :errors="errorFor('subject')"></v-errors>
                            </div>
                        </div>
                    </div>
                    <div class="col_12">
                        <div class="row">
                            <div class="col_10">
                                <div :class="['form_row', {'has_error': errorFor('contact_id')}]">
                                    <label class="required">Contact Email</label>
                                    <Multiselect
                                        v-model="selectedContact"
                                        :options="contacts"
                                        :multiple="false"
                                        :close-on-select="true"
                                        placeholder="Select a contact"
                                        label="name"
                                        :optionHeight="20"
                                        track-by="id"
                                        :custom-label="nameWithEmail"
                                        @Select="onContactSelect"
                                        @remove="onContactRemove"
                                    />
                                    <v-errors :errors="errorFor('contact_id')"></v-errors>
                                </div>
                            </div>
                            <div class="col_2 m-auto">
                                <button class="btn btn_primary" @click="openModal">Add New</button>
                            </div>
                        </div>
                    </div>
                    <div class="col_6">
                        <div :class="['form_row', {'has_error': errorFor('customer_name')}]">
                            <label>Contact name</label>
                            <div class="form_inline">
                                <input type="text" class="form_global" v-model="ticket.customer_name">
                                <v-errors :errors="errorFor('customer_name')"></v-errors>
                            </div>
                        </div>
                    </div>
                    <div class="col_6">
                        <div :class="['form_row', {'has_error': errorFor('customer_phone')}]">
                            <label>Contact phone</label>
                            <div class="form_inline">
                                <input type="text" class="form_global" v-model="ticket.customer_phone">
                                <v-errors :errors="errorFor('customer_phone')"></v-errors>
                            </div>
                        </div>
                    </div>
                </div>
                <div :class="['form_row', {'has_error': errorFor('description')}]">
                    <label class="required">Description</label>
                    <div class="form_inline">
                        <text-editor v-model:text="ticket['description']" :id="'description'"></text-editor>
                        <v-errors :errors="errorFor('description')"></v-errors>
                    </div>
                </div>
                <div class="custom_tab_content_inner" :class="[{'has_error': errorFor('attachments')}]">
                    <div class="product_list_wrap">
                        <h3>Email attachments</h3>
                        <div class="upload_btn dropzone-clickable mt_5 mb_10">
                            <button type="button" class="btn btn_black width_150p">Upload files</button>
                        </div>
                        <div class="product_list">
                            <draggable
                                :list="ticket.attachments"
                                item-key="image"
                                tag="ul"
                                ghost-class="ghost"
                                @end="imageSorted"
                            >
                                <template #item="{ element, index }">
                                <li>
                                    <div class="inner">
                                    <div class="img">
                                        <template v-if="['gif', 'png', 'jpg', 'jpeg', 'JPG'].includes(element.file_extension)">
                                        <div class="cross_ic" @click="removeDragImage(element, index)"><i class="fas fa-times"></i></div>
                                        <img :src="element.file_path">
                                        </template>
                                        <template v-if="['pdf'].includes(element.file_extension)">
                                        <div class="cross_ic" @click="removeDragImage(element, index)"><i class="fas fa-times"></i></div>
                                        <embed :src="element.file_path">
                                        </template>
                                        <template v-if="['xls','xlsx','xlm','xla','xlc','xlt','xlw','csv'].includes(element.file_extension)">
                                        <div class="cross_ic" @click="removeDragImage(element, index)"><i class="fas fa-times"></i></div>
                                        <i class="fas fa-file-excel fa-10x"></i>
                                        </template>
                                        <template v-if="['docx'].includes(element.file_extension)">
                                        <div class="cross_ic" @click="removeDragImage(element, index)"><i class="fas fa-times"></i></div>
                                        <i class="fas fa-file-word fa-10x"></i>
                                        </template>
                                        <template v-if="['zip'].includes(element.file_extension)">
                                        <div class="cross_ic" @click="removeDragImage(element, index)"><i class="fas fa-times"></i></div>
                                        <i class="fas fa-file-archive fa-10x"></i>
                                        </template>
                                        <!-- <template v-if="allErrors && allErrors['attachments.'+index]">
                                            pgh
                                            <small v-for="(error, errorIndex) in allErrors['attachments.'+index]" :key="'error_' + index + '_attachments_'+errorIndex">{{error}}</small>
                                        </template> -->
                                    </div>
                                    </div>
                                </li>
                                </template>
                            </draggable>
                        </div>
                        <div class="dropzone-previews"></div>
                        <div class="dropzone_wrap">
                            <div class="create_images_drag dropzone-clickable dropzone-container">
                                <div class="images">
                                <span>Drag and drop images from your computer.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom_btn">
                <button type="button" class="btn btn_transparent has_border_radius" @click="closeCreateChatTicket">Cancel</button>
                <button type="button" class="btn btn_black has_border_radius ml_10 width_100p" @click="submitCreateTicket" :disabled="isSubmitting">Save</button>
            </div>
        </div>

        <BaseModal
            v-if="isShowContactModal"
            title="Add Contact"
            :closeModal="closeModal"
            size="modal_850p"
        >
        <AddContactComponent
            :closeModal="closeModal"
            :addNewContract="addNewContract"
            @send-data="receiveCreatedContract"
        />
        </BaseModal>
    </div>
  </div>
</template>

<script>
    import LoaderMaskComponent from "@/components/LoaderMaskComponent.vue";
    import TextEditor from "@/components/shared/TextEditor";
    import Multiselect from 'vue-multiselect';
    import BaseModal from "@/components/BaseModal.vue";
    import AddContactComponent from "@/components/shared/contact/AddContractComponent.vue";
    import draggable from "vuedraggable";
    import Dropzone from "dropzone";
    import {mapGetters} from "vuex";
    export default {
        name: 'support-request-view',
        components: {LoaderMaskComponent, TextEditor, Multiselect, BaseModal, AddContactComponent, draggable},
        data(){
            return {
                lyLoading: false,
                singleTicket: null,
                isOpenTicketCreate: false,
                isShowContactModal: false,
                isSubmitting: false,
                groups: [],
                contacts: [],
                users:[],
                selectedGroup: null,
                selectedUser: null,
                selectedStatus: null,
                selectedPriority: null,
                selectedContact: null,
                selectedCcContact: null,
                statuses:[
                    {
                        label:'open',
                        name: 'Open'
                    },
                    {
                        label:'pending',
                        name: 'Pending'
                    },
                    {
                        label:'resolved',
                        name: 'Resolved'
                    },
                    {
                        label:'closed',
                        name: 'Closed'
                    },

                ],
                priorities:[
                    {
                        label:'low',
                        name: 'Low'
                    },
                    {
                        label:'medium',
                        name: 'Medium'
                    },
                    {
                        label:'high',
                        name: 'High'
                    },
                    {
                        label:'urgent',
                        name: 'Urgent'
                    },

                ],
                ticket: {
                    group_id: '',
                    user_id: '',
                    status: '',
                    priority: '',
                    company_id: '',
                    contact_id: '',
                    customer_email: '',
                    customer_name: '',
                    customer_phone: '',
                    cc_contact_id: '',
                    cc_email: '',
                    subject: '',
                    description: '',
                    request_from: 'website',
                    support_request_id: '',
                    attachments:[]
                },
                showTickets: false
            }
        },
        watch: {
            $route(to, from) {
                if(to.name == from.name && !window._.isEqual(to, from)){
                    this.loadContactData(this.$route.params.id)
                }
            },
        },
        created() {
            if(this.$route.params.id){
              this.loadContactData(this.$route.params.id)
            }
        },
        computed: {
            ...mapGetters({
                user: 'auth/getUser',
            })
        },
        mounted(){
            this.ticketDetailsScrollbar()
            this.getGroups()
            this.getContacts()
        },
        beforeUnmount() {
            this.closeCreateChatTicket();
        },
        methods: {
            viewTicketsToggle(){
                if(this.showTickets){
                    this.showTickets = false
                }else{
                    this.showTickets = true
                }
            },
            loadContactData(contactId){
                this.lyLoading = true;
                this.axios.get('/support-requests/'+contactId)
                .then((response) => {
                    this.ticketDetailsScrollbar()
                    this.singleTicket = response.data.data
                    setTimeout(() => {
                        this.initDropzone()
                    },1000)
                })
                .catch(() => {
                    this.showFailMsg("No request exists!");
                })
                .finally(() => {
                    this.lyLoading = false;
                })
            },
            initDropzone(){
                let that = this;
                const user = JSON.parse(localStorage.getItem('admin'))|| null
                new Dropzone(".dropzone-container", {
                    clickable: '.dropzone-clickable',
                    disablePreviews: true, // will not show preview
                    createImageThumbnails: true,
                    addRemoveLinks: true,
                    previewsContainer: '.dropzone-previews',
                    maxFiles: 2000,
                    headers: {
                        'Authorization': `Bearer ${user.token}`
                    },
                    url: `${process.env.VUE_APP_API_BASE_URL}/temporary-image-upload`,
                    success: function (file, response) {
                        let image = {
                            id: '',
                            sort: that.ticket.attachments.length + 1,
                            draft: response.draft,
                            file_extension: response.file_extension,
                            file_path: response.file_path,
                            original_file_name: response.original_file_name,
                            original_size: response.original_size,
                        }
                        that.ticket.attachments.push(image)
                        // since no preview there is nothing to remove
                        // this.removeFile(file); // This line removes the preview
                    },
                    error: function (file, response) {
                        let errors = that.errors ? that.errors : {};
                        errors.attachments = (errors && errors.attachments) ? errors.attachments : [];
                        errors.attachments = response.errors.file
                        that.errors = errors;
                        // this.removeFile(file);
                    },
                    removedfile: function() {
                        let errors = that.errors ? that.errors : {};
                        errors.attachments = null;
                        that.errors = errors;
                        // since no preview there is nothing to remove
                        // file.previewElement.remove();
                    }
                });
            },
            openCreateChatTicket(){
                this.ticket.subject = this.singleTicket.subject
                this.ticket.description = this.singleTicket.message
                this.ticket.customer_id = this.singleTicket.customer_id
                this.ticket.company_id = this.singleTicket.company_id
                this.ticket.contact_id = this.singleTicket.contact_id
                this.ticket.customer_email = this.singleTicket.email
                this.ticket.customer_name = this.singleTicket.name
                this.ticket.customer_phone = this.singleTicket.phone
                this.ticket.group_id = this.singleTicket.group_id
                this.ticket.support_request_id = this.singleTicket.id
                var contact = this.contacts.filter(contact => contact.id == this.singleTicket.contact_id);
                if(contact && contact.length > 0){
                    this.selectedContact = contact[0];
                }
                var group = this.groups.filter(group => group.id == this.singleTicket.group_id);
                if(group && group.length > 0){
                    this.selectedGroup = group[0];
                    this.users = group[0].users
                }
                document.body.classList.add("right_menu_open");
            },
            openModal(){
                this.isShowContactModal = true;
            },
            closeModal(){
                this.isShowContactModal = false;
            },
            closeCreateChatTicket(){
                document.body.classList.remove("right_menu_open");
            },
            nameWithEmail(data){
                return `${data.name} — [ ${data.email} ]`;
            },
            getGroups() {
                this.axios.get('/active-groups-for-relation').then(({data}) => {
                    this.groups = data.data
                })
            },
            receiveCreatedContract(contract){
                if (contract && contract.id) {
                    this.ticket.contact_id = contract.id;
                    this.getContacts();
                    this.selectedContact = contract;
                    this.onContactSelect(contract);
                }
            },
            addNewContract(){
                this.axios.post('').then(() => {})
            },
            getContacts() {
                this.axios.get('/active-contacts-for-relation').then(({data}) => {
                    this.contacts = data.data
                })
            },
            onGroupSelect(selected){
                this.ticket.group_id = selected.id
                this.users = selected.users
                this.selectedUser = null
                this.ticket.user_id = ''
            },
            onGroupRemove(){
                this.selectedGroup = null
                this.ticket.group_id = ''
                this.selectedUser = null
                this.ticket.user_id = ''
            },
            onStatusSelect(selected){
                this.ticket.status = selected.label
            },
            onStatusRemove(){
                this.ticket.status = ''
            },
            onPrioritySelect(selected){
                this.ticket.priority = selected.label
            },
            onPriorityRemove(){
                this.ticket.priority = ''
            },
            onUserSelect(selected){
                this.ticket.user_id = selected.id
            },
            onUserRemove(){
                this.selectedUser = null
                this.ticket.user_id = ''
            },
            onContactSelect(selected){
                this.ticket.contact_id = selected.id
                this.ticket.company_id = selected.company_id
                this.ticket.customer_email = selected.email
                this.ticket.customer_name = selected.name
                this.ticket.customer_phone = selected.phone
            },
            onContactRemove(){
                this.selectedContact = null
                this.ticket.contact_id = ''
                this.ticket.company_id = ''
                this.ticket.customer_email = ''
                this.ticket.customer_name = ''
                this.ticket.customer_phone = ''
            },
            submitCreateTicket(){
                this.isSubmitting = true
                this.allErrors = null;
                let formData = new FormData();
                Object.keys(this.ticket).forEach(key => {
                    formData.append(key, this.ticket[key] ? this.ticket[key] : '');
                })
                formData.append('user', JSON.stringify(this.user))
                formData.append('attachments', JSON.stringify(this.ticket.attachments))

                formData.delete('user_id')
                formData.append('user_id', this.selectedUser?.map(user => user.id) ?? '');

                this.axios.post('/tickets', formData).then(() => {
                    this.loadContactData(this.$route.params.id)
                    this.closeCreateChatTicket();
                    this.resetForm();
                    this.showSuccessMsg("Ticket Created Successfully!");
                }).catch((err) => {
                    this.allErrors = err.response.data.errors
                }).finally(() => {
                    this.isSubmitting = false
                })
            },
            removeDragImage(element, index){
                if(!this.ticket) return;
                if(!this.ticket.attachments) return;
                if (!element.id) {
                    let formData = new FormData()
                    formData.append('draft', element.draft);
                        this.axios.post('/temporary-image-remove', formData).then(() => {
                    });
                }
                this.ticket.attachments.splice(index, 1)
                this.imageSorted();
            },
            imageSorted() {
                let sort = 1;
                for (let index = 0; index < this.ticket.attachments.length; index++) {
                    this.ticket.attachments[index].sort = sort++;
                }
            },
            resetForm(){
                this.selectedStatus = null
                this.selectedPriority = null
                this.onGroupRemove()
                this.onUserRemove()
                this.onContactRemove()
                this.ticket = {
                    group_id: '',
                    user_id: '',
                    status: '',
                    priority: '',
                    company_id: '',
                    contact_id: '',
                    customer_email: '',
                    customer_name: '',
                    customer_phone: '',
                    cc_contact_id: '',
                    cc_email: '',
                    subject: '',
                    description: '',
                    request_from: 'website',
                    support_request_id: '',
                    attachments:[]
                }
            },
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style scoped lang="scss">
  .create_item_tab button {
    position: relative;
    float: right;
    right: 0;
    top: 0;
  }
  .btn_back{
    position: relative;
    float: right;
    right: 0;
    top: 0;
  }
  .font_italic{
    position: relative;
    display: block;
    left: 120px;
    padding-top: 5px;
  }
  .multiselect__tags {
    border-radius: 0;
  }
  .create_images_drag {
    position: relative;
    width: 100%;
    background: #efefef;
    min-height: 212px;
    margin-bottom: 10px;
  }

  .create_images_drag span {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    font-size: 18px;
    color: #999;
  }
  .inner{
    // border: 1px solid #E2E2E2 !important;
  }
  .product_list_wrap {
    .upload_btn {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      span {
        margin-left: 20px;
      }
    }
    .product_list {
      ul {
        display: flex;
        flex-wrap: wrap;
        margin-left: -5px;
        margin-right: -5px;
        li {
          width: 20%;
          padding-left: 5px;
          padding-right: 5px;
          padding-bottom: 10px;
          .inner {
            .img {
              position: relative;
              overflow: hidden;
              transition: all .3s;
              img {
                width: 100%;
              }
              .cross_ic {
                position: absolute;
                top: 20px;
                right: 3px;
                z-index: 2;
                background: red;
                border-radius: 50%;
                width: 20px;
                height: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 15px;
                opacity: 0;
              }
              &:hover {
                transition: all .3s;
                .cross_ic {
                  opacity: 1;
                  top: 3px;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
